import { LABEL_TYPES } from "@skylead/component-library/src/components/atoms/Switch"
import { CELL_VARIANT } from "@skylead/component-library/src/components/atoms/TableCell"
import moment from "moment"
import React, { useMemo } from "react"

import Button, { ButtonVariant } from "../components/atoms/Button"
import TableCell from "../components/atoms/TableCell"
import { useGlobalTranslation } from "../utils/hook"

const getCampaignIcon = leadSources => {
  if (leadSources.length > 1) {
    return "stack-2-36"
  }

  switch (leadSources[0]?.type) {
    case "SALES_NAVIGATOR":
      return "compass-36"
    case "LEADS_LIST":
      return "list-details-36"
    case "POST_ENGAGEMENT":
      return "file-like-36"
    case "BASIC":
      return "brand-linkedin-36"
    case "CSV":
      return "file-type-csv-36"
    case "RECRUITER":
    case "TALENT_LIST":
      return "user-search-36"
    default:
      return "file-type-csv-36"
  }
}

const getCampaignInputLabel = (tt, leadSources) => {
  if (leadSources.length > 1) {
    return tt("multiple-sources")
  }

  switch (leadSources[0]?.type) {
    case "SALES_NAVIGATOR":
      return tt("sales.navigation.search.result")
    case "LEADS_LIST":
      return tt("sales.navigator.lead.list")
    case "POST_ENGAGEMENT":
      return tt("linkedin.post")
    case "BASIC":
      return tt("linkedin.search.result")
    case "CSV":
      return tt("import")
    case "RECRUITER":
    case "TALENT_LIST":
      return tt("recruiter.search.result")
    default:
      return tt("import")
  }
}

export const useLeadListsColumnsHook = (renderLeadListsMenu, language) => {
  const { tt } = useGlobalTranslation()

  const leadListsColumns = useMemo(() => {
    return {
      left: [
        {
          id: "1",
          name: tt("list-name"),
          className: "leads-name-column table-cell-padding",
          key: "listName",
          sortable: { label: "listName" },
          component: item => (
            <TableCell
              cellType={CELL_VARIANT.TEXT}
              labelType={LABEL_TYPES.NONE}
              text={item.name}
              tt={tt}
            />
          ),
        },
      ],
      center: [
        {
          id: "2",
          name: tt("discovery-source"),
          className: "discovery-source-column table-cell-padding",
          key: "discoverySource",
          sortable: { label: "discoverySource" },
          component: item => {
            const discoveryInProgress =
              item.sources && item.sources.some(source => source.status === "ACTIVE")
            return (
              <TableCell
                cellType={CELL_VARIANT.TEXT}
                textCellIcon={getCampaignIcon(item.sources)}
                text={getCampaignInputLabel(tt, item.sources)}
                helperText={discoveryInProgress ? tt("discovery.in-progress") : null}
                tt={tt}
              />
            )
          },
        },
        {
          id: "3",
          name: tt("total-leads"),
          className: "total-leads-column table-cell-padding",
          key: "totalLeads",
          sortable: { label: "totalLeads" },
          component: item => (
            <TableCell
              cellType={CELL_VARIANT.TEXT}
              labelType={LABEL_TYPES.NONE}
              text={item.prospectCount}
              tt={tt}
            />
          ),
        },
        {
          id: "4",
          name: tt("created-at"),
          className: "created-at-column table-cell-padding",
          key: "createdAt",
          sortable: { label: "createdAt" },
          component: item => (
            <TableCell
              cellType={CELL_VARIANT.TEXT}
              labelType={LABEL_TYPES.NONE}
              text={moment(item.createdAt).locale(language).fromNow()}
              tt={tt}
            />
          ),
        },
      ],
      right: [
        {
          className: "lead-lists-table-row-menu table-cell-padding",
          component: item => (
            <Button
              variant={ButtonVariant.GHOST}
              icon="dots-vertical-20"
              onClick={event => {
                renderLeadListsMenu(event, item)
              }}
              tooltipText={tt("menu")}
              tooltipTop={-4}
              tooltipLeft={60}
              caretLeft
            />
          ),
        },
      ],
    }
  }, [renderLeadListsMenu, tt, language])
  return leadListsColumns
}
